import styled from 'styled-components'

import { Z_INDEX_OVERLAY } from 'src/constants/z-indexes'
import { color } from 'src/styles/colors'
import { media } from 'src/styles/media'
import { fontFamily, fontWeight } from 'src/styles'
import { fontSize } from 'src/styles/fonts'

interface OverlayProps {
  isOpen: boolean
}

export const Overlay = styled.div<OverlayProps>`
  position: absolute;
  top: 0;
  z-index: ${Z_INDEX_OVERLAY};
  width: 100vw;
  height: 100%;
  display: ${(p) => (p.isOpen ? 'flex' : 'none')};
  justify-content: flex-end;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`

export const Title = styled.h2`
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontWeight.EXTRA};
  line-height: 1.5;
  text-align: center;
  color: ${color.GREYISH_BROWN};
  margin: 3.2rem 0 0.8rem;
  align-self: center;

  ${media.desktop} {
    font-size: ${fontSize.LARGE_XXXL};
    line-height: 1;
    text-align: center;
    color: ${color.GREYISH_BROWN};
    margin: 3.2rem 0 4.8rem;
    align-self: flex-start;
  }
`

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 3rem;

  ${media.desktop} {
    padding: 5.6rem 12rem 3rem;
  }
`

export const ContentWrap = styled.div`
  width: 100%;
  min-height: 100%;
  height: 100%;
  background-color: ${color.WHITE};
  overflow: auto;

  ${media.desktop} {
    width: 50%;
    padding-top: 5.6rem;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;

  ${media.desktop} {
    top: 2.4rem;
    right: 3.2rem;
  }
`

export const Button = styled.button`
  height: 5.6rem;
  border-radius: 2.8rem;
  background-color: ${color.DULL_ORANGE};
  padding: 0 4rem;
  font-family: ${fontFamily.CATAMARAN};
  font-weight: ${fontWeight.BOLD};
  font-size: ${fontSize.NORMAL};
  line-height: 1.5;
  text-align: center;
  color: ${color.WHITE};
  margin-top: 3rem;
  align-self: center;

  :disabled {
    background-color: rgba(87, 61, 57, 0.1);
  }
`
